/* core */
import './core/lenis.js'
/* components */
import './components/burger.js'
import './components/toc.js'
import './components/select2.js'

// Function
import './functions/validate-forms.js'

/* modules */
import './modules/common.js'
import './modules/home.js'
import './modules/about.js'
import './modules/brand.js'
import './modules/product.js'
import './modules/career.js'
import './modules/contact.js'

$(document).ready(function() {
  console.log('jQuery is ready!')
})
